module.exports = __webpack_public_path__ + "static/profile-143f6fa543663d5dc88d7168dfe85aa5.png";